import React, { useState } from "react";
import { ReactComponent as BackIcon } from "../../images/back.svg";
import { ReactComponent as BlueArrow } from "../../images/bluearrow.svg";
import { ReactComponent as DollarIcon } from "../../images/dollaricon.svg";
import { ReactComponent as Payment } from "../../images/payment_done.svg";
import { ReactComponent as History } from "../../images/history.svg";
import SummaryTable from "./SummaryTable";
import { Button, DatePicker, Modal, Popover } from "antd";
import StepProgressBar from "../../components/StepProgressBar/StepProgressBar";
import SwitchBox from "../../components/SwitchBox/SwitchBox";
import SearchInput from "../../components/SearchInput/SearchInput";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../axios/axios";
import moment from "moment";
import { useEffect } from "react";
import { toast } from "react-toastify";
import TextArea from "../../components/Form/TextArea";
import FileUploadComponent from "../../components/FileUpload/FileUpload";
import dayjs from "dayjs";
import FileUploadWithThumb from "../../components/FileUploadWithThumb/FileUploadWithThum";
import { API } from "../../common/Constants";
import { handleDownload, handleSummaryDownload } from "../../common/Utilities";

export const DetailSummaryList = [
  { id: "weekly", name: "Weekly" },
  { id: "monthly", name: "Monthly" },
  { id: "quarterly", name: "Quarterly" },
  { id: "yearly", name: "Yearly" },
];
const FilterDateFormat = "YYYY-MM-DD";
const DefaultPaymentObj = {
  paid_tier: "",
  paid_amount: "",
  no_of_cases: "",
  no_of_rejected_cases: "",
  bonus_distribution_period: "",
  payment_date: null,
  remarks: "",
  document_uploaded: [],
};

const FormatFilterDate = (dateValue, type, format) => {
  if (dateValue !== undefined) {
    if (type === "week") {
      if (dateValue?.length < 10) {
        const FormattedDate = `${dateValue?.slice(0, 4)}-${Number(
          dateValue?.slice(5, 7)
        )}th`;

        console.log("FORMATTEDVALUE", FormattedDate, dateValue);
        const startDate = moment(FormattedDate, "YYYY-WW").startOf(type);
        const endDate = moment(FormattedDate, "YYYY-WW").endOf(type);
        return {
          startDate: startDate.format(format),
          endDate: endDate.format(format),
        };
      } else {
        const startDate = moment(dateValue, "YYYY-WW").startOf(type);
        const endDate = moment(dateValue, "YYYY-WW").endOf(type);
        return {
          startDate: startDate.format(format),
          endDate: endDate.format(format),
        };
      }
    } else if (type === "quarter") {
      const startDate = moment().quarter(dateValue).startOf("quarter");
      const endDate = moment().quarter(dateValue).endOf("quarter");
      return {
        startDate: startDate.format(format),
        endDate: endDate.format(format),
      };
    } else {
      const startDate = moment(dateValue).startOf(type);
      const endDate = moment(dateValue).endOf(type);
      return {
        startDate: startDate.format(format),
        endDate: endDate.format(format),
      };
    }
  }
  return "";
};

const defaultFilters = {
  weekly: { startDate: "", endDate: "" },
  monthly: { startDate: "", endDate: "" },
  quarterly: { startDate: "", endDate: "" },
  yearly: { startDate: "", endDate: "" },
};

const DetailSummary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bonusId = location.state?.bonusId;
  const tabId = location.state?.tabId;

  const [showTierInfo, setShowTierInfo] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [bonusSummaryDetails, setBonusSummaryDetails] = useState({});
  const [filter, setFilter] = useState(
    tabId !== null && tabId !== undefined && tabId !== "" ? tabId : "weekly"
  );
  console.log("FILTER", location, filter);
  const [periodicalData, setPeriodicalData] = useState({});
  const [rejectReason, setRejectReason] = useState("");
  const [isOpenReject, setisOpenReject] = useState({
    open: false,
    id: "",
    type: "",
  });
  const [selectedWeek, setSelectedWeek] = useState(moment());
  const [selectedMonth, setSelectedMonth] = useState(moment().startOf("month"));
  const [selectedQuarter, setSelectedQuarter] = useState(moment().quarter());
  const [selectedYear, setSelectedYear] = useState(moment().startOf("year"));
  const [openDatePicker, setOpenDatePicker] = useState({
    weekly: false,
    monthly: false,
    quarterly: false,
    yearly: false,
  });
  const GetSelectedDateType = (type) => {
    switch (type) {
      case "weekly":
        return selectedWeek;
      case "monthly":
        return selectedMonth;
      case "quarterly":
        return selectedQuarter;
      case "yearly":
        return selectedYear;
      default:
        break;
    }
  };

  const GetDateType = (type) => {
    switch (type) {
      case "weekly":
        return "week";
      case "monthly":
        return "month";
      case "quarterly":
        return "quarter";
      case "yearly":
        return "year";
      default:
        break;
    }
  };

  const [bonusSummaryFilters, setbonusSummaryFilters] = useState({
    weekly: {
      startDate: FormatFilterDate(
        GetSelectedDateType(filter),
        GetDateType(filter),
        "YYYY-MM-DD"
      )?.startDate,
      endDate: FormatFilterDate(
        GetSelectedDateType(filter),
        GetDateType(filter),
        "YYYY-MM-DD"
      )?.endDate,
    },
    monthly: { startDate: "", endDate: "" },
    quarterly: { startDate: "", endDate: "" },
    yearly: { startDate: "", endDate: "" },
  });

  const [isPayment, setisPayment] = useState(false);
  const [paymentData, setPaymentData] = useState(DefaultPaymentObj);

  useEffect(() => {
    if (Object.keys(periodicalData)?.length > 0) {
      setPaymentData({
        ...paymentData,
        paid_tier: periodicalData?.paid_tier,
        paid_amount: periodicalData?.bonus_amount,
        no_of_cases: periodicalData?.no_of_cases,
        no_of_rejected_cases: periodicalData?.no_of_rejected_cases,
        bonus_distribution_period: periodicalData?.value,
      });
    }
  }, [periodicalData]);

  const GetBonusSummaryDetails = async (filter) => {
    const resp = await axios.post(`/bonus/summary/info/${bonusId}`, filter);
    if (resp.status < 400) {
      setBonusSummaryDetails(resp.data?.data);
    }
  };

  const HandleReject = async (type, id) => {
    const resp = await axios.put(
      `bonus/summary/rejection/update/${id}/${type == 1 ? 0 : 1}`,
      {
        reason: rejectReason,
      }
    );
    if (resp.status) {
      toast.success(resp.data?.message);
      setisOpenReject({
        open: false,
        id: "",
        type: "",
      });
      GetBonusSummaryDetails(bonusSummaryFilters);
    }
  };

  useEffect(() => {
    if (bonusId !== null && bonusId !== undefined) {
      GetBonusSummaryDetails(bonusSummaryFilters);
    }
  }, []);

  const onTabFilterchange = (type, data) => {
    setbonusSummaryFilters({
      ...defaultFilters,
      [type]: data,
    });
    GetBonusSummaryDetails({
      ...defaultFilters,
      [type]: data,
    });
  }
  const handleSettingsChange = (idx, title, tabId) => {
    const weekly = {
      startDate: FormatFilterDate(
        GetSelectedDateType("weekly"),
        GetDateType("weekly"),
        "YYYY-MM-DD"
      )?.startDate,
      endDate: FormatFilterDate(
        GetSelectedDateType("weekly"),
        GetDateType("weekly"),
        "YYYY-MM-DD"
      )?.endDate,
    };
    const Monthly = {
      startDate: FormatFilterDate(moment(), "month", FilterDateFormat)
        ?.startDate,
      endDate: FormatFilterDate(moment(), "month", FilterDateFormat)?.endDate,
    };
    const quaterly = {
      startDate: FormatFilterDate(
        moment().quarter(),
        "quarter",
        FilterDateFormat,
        moment()
      )?.startDate,
      endDate: FormatFilterDate(
        moment().quarter(),
        "quarter",
        FilterDateFormat,
        moment()
      )?.endDate,
    };
    const yearly = {
      startDate: FormatFilterDate(moment(), "year", FilterDateFormat)
        ?.startDate,
      endDate: FormatFilterDate(moment(), "year", FilterDateFormat)?.endDate,
    };
    console.log("TITLE", weekly, Monthly, quaterly, yearly);
    if (tabId === "weekly") {
      onTabFilterchange(tabId, weekly)
    } else if (tabId === "monthly") {
      onTabFilterchange(tabId, Monthly)

    } else if (tabId === "quarterly") {
      onTabFilterchange(tabId, quaterly)

    } else {
      onTabFilterchange(tabId, yearly)
    }
    setFilter(tabId);
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleWeekChange = (date, dateString) => {
    console.log("DTESTRIKNGG", date, dateString);
    if (date !== null && date !== undefined) {
      setSelectedWeek(dateString);
      setbonusSummaryFilters({
        ...defaultFilters,
        weekly: FormatFilterDate(dateString, "week", FilterDateFormat),
      });
      GetBonusSummaryDetails({
        ...defaultFilters,
        weekly: FormatFilterDate(dateString, "week", FilterDateFormat),
      });
    } else {
      setSelectedWeek(moment().startOf("week"));
      setbonusSummaryFilters({
        ...defaultFilters,
        weekly: FormatFilterDate(moment(), "week", FilterDateFormat),
      });
      GetBonusSummaryDetails({
        ...defaultFilters,
        weekly: FormatFilterDate(dateString, "week", FilterDateFormat),
      });
    }
  };

  const handleMonthChange = (date, dateString) => {
    if (date !== null && date !== "") {
      setSelectedMonth(dateString);
      setbonusSummaryFilters({
        ...defaultFilters,
        monthly: FormatFilterDate(dateString, "month", FilterDateFormat),
      });
      GetBonusSummaryDetails({
        ...defaultFilters,
        monthly: FormatFilterDate(dateString, "month", FilterDateFormat),
      });
    } else {
      setSelectedMonth(moment().startOf("month"));
      setbonusSummaryFilters({
        ...defaultFilters,
        monthly: FormatFilterDate(moment(), "month", FilterDateFormat),
      });
      GetBonusSummaryDetails({
        ...bonusSummaryFilters,
        monthly: FormatFilterDate(dateString, "month", FilterDateFormat),
      });
    }
  };

  const handleQuarterChange = (date, dateString) => {
    if (date !== null && date !== "") {
      setSelectedQuarter(dateString.charAt(dateString.length - 1));
      setbonusSummaryFilters({
        ...defaultFilters,
        quarterly: FormatFilterDate(
          dateString.charAt(dateString.length - 1),
          "quarter",
          FilterDateFormat,
          date
        ),
      });
      GetBonusSummaryDetails({
        ...defaultFilters,
        quarterly: FormatFilterDate(
          dateString.charAt(dateString.length - 1),
          "quarter",
          FilterDateFormat,
          date
        ),
      });
    } else {
      setSelectedQuarter(moment().quarter());
      setbonusSummaryFilters({
        ...defaultFilters,
        quarterly: FormatFilterDate(
          moment().quarter(),
          "quarter",
          FilterDateFormat,
          date
        ),
      });
      GetBonusSummaryDetails({
        ...defaultFilters,
        quarterly: FormatFilterDate(
          dateString.charAt(dateString.length - 1),
          "quarter",
          FilterDateFormat,
          date
        ),
      });
    }
  };

  const handleYearChange = (date, dateString) => {
    if (date !== null && date !== "") {
      setSelectedYear(dateString);
      setbonusSummaryFilters({
        ...defaultFilters,
        yearly: FormatFilterDate(dateString, "year", FilterDateFormat),
      });
      GetBonusSummaryDetails({
        ...defaultFilters,
        yearly: FormatFilterDate(dateString, "year", FilterDateFormat),
      });
    } else {
      setSelectedYear(moment());
      setbonusSummaryFilters({
        ...defaultFilters,
        yearly: FormatFilterDate(moment(), "year", FilterDateFormat),
      });
      GetBonusSummaryDetails({
        ...defaultFilters,
        yearly: FormatFilterDate(dateString, "year", FilterDateFormat),
      });
    }
  };
  useEffect(() => {
    if (filter !== "" && Object.keys(bonusSummaryDetails)?.length > 0) {
      const temp = bonusSummaryDetails?.periodicalData
        ?.filter((it) => it?.value === filter)
        .pop();
      if (temp !== undefined) {
        setPeriodicalData(temp);
      } else {
        setPeriodicalData({});
      }
    }
  }, [filter, bonusSummaryDetails]);

  const GetDatePicker = (type) => {
    switch (type) {
      case "weekly":
        return <DatePicker.WeekPicker onChange={handleWeekChange} />;
      case "monthly":
        return <DatePicker.MonthPicker onChange={handleMonthChange} />;
      case "quarterly":
        return <DatePicker.QuarterPicker onChange={handleQuarterChange} />;
      case "yearly":
        return <DatePicker.YearPicker onChange={handleYearChange} allowClear />;
      default:
        break;
    }
  };

  const handleselPayment = () => {
    setisPayment(false);
    setPaymentData(DefaultPaymentObj);
  };

  const handlePayment = async () => {
    const resp = await axios.post(`/bonus/summary/payment/${bonusId}`, {
      ...paymentData,
      payment_date: dayjs(paymentData?.payment_date, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      ),
    });
    if (resp.status < 400) {
      GetBonusSummaryDetails();
      toast.success(resp.data?.message);
      setisPayment(false);
    }
  };

  const handleFileUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("module", "agent");
    console.log("UPLOADFILE", file);
    try {
      const response = await axios
        .post("/upload/image", formData)
        .then((resp) => {
          setPaymentData({
            ...paymentData,
            document_uploaded: paymentData?.document_uploaded?.concat({
              name: file.name,
              value: resp.data?.data,
            }),
          });
          toast.success(resp.data?.message);
          onSuccess();
        });
    } catch (error) {
      onError(error);
    }
  };
  console.log("paymentData", bonusSummaryFilters);

  return (
    Object.keys(bonusSummaryDetails)?.length > 0 && (
      <section className="common_container">
        <header className="common-header flex justify-between flex-wrap gap-4">
          <div className="common-header-body">
            <h1 className=" flex items-center gap-3">
              <span
                className="cursor-pointer"
                onClick={() => {
                  localStorage.removeItem(`${bonusSummaryDetails?.id}`);
                  navigate("/bonus-summary");
                }}
              >
                <BackIcon />
              </span>
              Detail Summary
            </h1>
            <SearchInput onChange={handleSearchChange} value={searchValue} />
          </div>
        </header>
        <section>
          <div className="tab-section">
            <SwitchBox
              tabs={DetailSummaryList}
              settingsHandle={handleSettingsChange}
              value={filter}
            />
            <div className="flex gap-5 items-center  mb-[15px]">
              <div className="detail_date_block">
                <h5>
                  {`${FormatFilterDate(
                    GetSelectedDateType(filter),
                    GetDateType(filter),
                    "DD MMM YYYY"
                  )?.startDate
                    } - ${FormatFilterDate(
                      GetSelectedDateType(filter),
                      GetDateType(filter),
                      "DD MMM YYYY"
                    )?.endDate
                    }`}
                </h5>
                <div className="custom-calendar-wrapper">
                  {GetDatePicker(filter)}
                </div>
              </div>
              <Button
                type="button"
                className="btn-primary"
                onClick={() => {
                  const temp = `${API.BaseUrl}export/bonus/summary/${bonusSummaryDetails?.id}/${filter}`;
                  handleSummaryDownload(temp, bonusSummaryFilters);
                }}
              >
                Export
              </Button>
            </div>
          </div>
          <div className="dealer-bonus-summary">
            <div className="bonus-summary-block">
              <button
                className="dealer-acc-btn"
                type="button"
                onClick={() => setShowTierInfo(!showTierInfo)}
              >
                <div className="dealer-summary-logo">
                  <img
                    src={`https://api.ohhto.com/${bonusSummaryDetails?.icon}`}
                    alt="dealer logo"
                  />
                </div>
                <span>{bonusSummaryDetails?.name}</span>
                <i className={`${showTierInfo ? "" : "down-arrow"} `}>
                  <BlueArrow />
                </i>
              </button>
              <div className="dealer-bonus-card-info">
                <div className="dealer-bonus-card-list">
                  <div className="bonus-card-info">
                    <div className="loan-amount">
                      <DollarIcon />
                    </div>
                    <div>
                      <h5>Total Loan Amount</h5>
                      <h6>${periodicalData?.total_amount}</h6>
                    </div>
                  </div>
                  <div className="bonus-card-info">
                    <div className="total-cases">
                      <DollarIcon />
                    </div>
                    <div>
                      <h5>Total Cases</h5>
                      <h6>{periodicalData?.no_of_applications}</h6>
                    </div>
                  </div>
                  <div className="bonus-card-info">
                    <div className="payable-amount">
                      <DollarIcon />
                    </div>
                    <div>
                      <h5>Bonus Amount Payable</h5>
                      <h6>
                        $
                        {localStorage.getItem(`${bonusSummaryDetails.id}`) !==
                          null
                          ? 0
                          : periodicalData?.bonus_amount}
                      </h6>
                    </div>
                  </div>
                </div>
                <Button
                  className="outline-btn"
                  onClick={() => {
                    //localStorage.setItem(`${bonusSummaryDetails?.id}`, true);
                    GetBonusSummaryDetails(bonusSummaryFilters);
                    setisPayment(true);
                  }}
                  disabled={
                    periodicalData?.bonus_amount == 0 ||
                    periodicalData?.bonus_amount == null ||
                    periodicalData?.is_payable == 0
                  }
                >
                  Make Payment
                </Button>
                <Button
                  className="outline-btn"
                  onClick={() => {
                    navigate("/bonus-summary/payment-history", {
                      state: location.state,
                    });
                  }}
                >
                  <span>
                    <History />
                  </span>
                  View
                </Button>
              </div>
            </div>
            {showTierInfo
              ? periodicalData?.dealerbonuses?.length > 0 &&
              periodicalData?.dealerbonuses?.map((it) => (
                <div>
                  <div className="dealer-tier-tittle">
                    <h2>{it?.name}</h2>
                    <div className="date-dealer">
                      <h6>
                        {moment(it?.startDate).format("DD MMM YYYY")} to{" "}
                        {moment(it?.endDate).format("DD MMM YYYY")}
                      </h6>
                      <Popover content="coming soon" placement="top">
                        <img
                          src="/images/fi_info.svg"
                          alt="info"
                          className="ml-[10px]"
                        />
                      </Popover>
                    </div>
                    <div className="flex">
                      <p>
                        Calendar <span>{it?.bonus_distribution_period}</span>{" "}
                        payout within
                        <span>{it?.payout_days}</span> days after end of
                        qualifying period
                      </p>
                      <Popover content="coming soon" placement="top">
                        <img
                          src="/images/fi_info.svg"
                          alt="info"
                          className="ml-[10px]"
                        />
                      </Popover>
                    </div>
                  </div>
                  <div className="dealer-tier-info">
                    <div className="tier-bonus-card-block">
                      <div className="tier-bonus-card-list">
                        {it?.qualifying_loan_amounts.map((item, index) => (
                          <div className="tier-bonus-list">
                            <span>{`Tier ${index + 1}`}</span>
                            <div className="tier-bonus-info">
                              <h5>Bonus Amount</h5>
                              <h6>
                                {item?.bonus_type == 1
                                  ? `${item?.bonus} %`
                                  : `$ ${item?.bonus}`}
                                {/* <i>
                                    <Payment />
                                  </i> */}
                              </h6>
                            </div>
                            <div className="tier-bonus-info">
                              <h5>Qualifying Amount</h5>
                              <h6>
                                ${item.minimum_loan_amount}-$
                                {item?.maximum_loan_amount}
                              </h6>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="bonus-progress-block">
                      <div className="bonus-progress">
                        <h2>Bonus Progress Summary</h2>
                        {/* <StepProgressBar
                            achievedValue={it?.achieved_amount}
                            targetValue={it?.total_amount}
                            stepData={periodicalData?.stepData}
                          /> */}
                        {console.log("periodicalData", periodicalData)}
                        <StepProgressBar
                          achievedValue={periodicalData?.achieved_amount}
                          // targetValue={CurrentData?.total_amount}
                          targetValue={parseFloat(
                            periodicalData?.stepData[
                              periodicalData?.stepData.length - 1
                            ]?.value
                          )}
                          currentStep={0}
                          stepData={periodicalData?.stepData}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))
              : null}
          </div>
          <div className="tab-body-section">
            <SummaryTable
              dataSource={periodicalData?.applications}
              HandleReject={HandleReject}
              rejectReason={rejectReason}
              setRejectReason={setRejectReason}
              isOpenReject={isOpenReject}
              setisOpenReject={setisOpenReject}
            />
          </div>

          <Modal
            open={isPayment}
            onCancel={handleselPayment}
            centered
            footer={null}
          >
            <div className="reject-popup-block">
              <h2 className="text-center">Make Payment</h2>
              <div className="input-group">
                <label>Bonus Payable Amount </label>
                <h2 className="!mb-0">${periodicalData?.bonus_amount}</h2>
              </div>
              <div className="input-group">
                <label>Payment Date</label>
                <DatePicker
                  placeholder="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  className={`py-[8px] md:max-w-[190px]`}
                  value={
                    paymentData?.payment_date !== null &&
                      paymentData?.payment_date !== undefined
                      ? dayjs(paymentData?.payment_date, "DD-MM-YYYY")
                      : null
                  }
                  onChange={(date, dateString) => {
                    setPaymentData({
                      ...paymentData,
                      payment_date:
                        date !== null && date !== undefined ? dateString : "",
                    });
                  }}
                />
              </div>
              <TextArea
                label="Remarks"
                placeholder="Reason to reject loan"
                value={paymentData?.remarks}
                onChange={(e) => {
                  setPaymentData({
                    ...paymentData,
                    remarks: e.target.value,
                  });
                }}
              />
              <FileUploadWithThumb
                label={"Document's"}
                onFileUpload={() => { }}
                onRemove={(file) => {
                  setPaymentData({
                    ...paymentData,
                    document_uploaded: paymentData?.document_uploaded?.filter(
                      (it) => it?.name !== file?.name
                    ),
                  });
                }}
                maxCount={1}
                CustomFileUpload={handleFileUpload}
              />{" "}
              <div className="reject-popup-btn">
                <Button
                  type="button"
                  className="can_btn"
                  onClick={() => {
                    handleselPayment();
                  }}
                >
                  Close
                </Button>
                <Button
                  className="sav_btn"
                  disabled={
                    paymentData?.payment_date === null ||
                    paymentData?.payment_date === "" ||
                    paymentData?.payment_date === "Invalid Date"
                  }
                  onClick={() => {
                    handlePayment();
                  }}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Modal>
        </section>
      </section>
    )
  );
};

export default DetailSummary;
